import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

// Função para atualizar o status da reserva

export const atualizarReservaService = async (
  reservaId: number | null,
  reservaData: any
) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/reserva/${reservaId}`;

    try {
      const response = await axios.patch(URL, reservaData, {
        headers: { Authorization: Token.AuthStr },
      });

      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.log(error);
      return false;
    }
  }

  return false;
};

export {};
